import React, {
  useMemo,
  useState,
} from 'react';


import { useNavigate } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  faChevronDown,
  faChevronUp,
  faCircleCheck,
  faCirclePlay,
  faCheck,
  faLock,
  faPlay,
  faBookOpen,
  faStar,
  faBullseye,
  faTrophy,
  faArrowRight,
} from '@fortawesome/free-solid-svg-icons';

import contiMascot from '../../../imagesHome/conti.png';
import TopBar from '../../functionalpagelogin/topBar/TopBar.jsx';
import ContaPrimaraSyllabus from './ContaPrimaraSyllabus.jsx';

import {
  contaPrimaraCourseData,
} from './data/contaPrimaraCourseData.js';

import './ContaPrimaraCourse.css';


/* =====================================================
   DATE CURS
===================================================== */

const courseUnits =
  contaPrimaraCourseData.units;


/* =====================================================
   PROGRES TEMPORAR

   Mai tarziu acest obiect va veni din backend.
===================================================== */

const mockProgress = {
  completedLessons: [
    '1-1',
    '1-2',
    '1-3',
    '1-4',
    '1-5',
  ],

  currentLesson: {
    unitId: 1,
    lessonId: 6,
  },
};


/* =====================================================
   COMPONENTA
===================================================== */

const ContaPrimaraCourse = () => {
  const navigate = useNavigate();

  const [openUnits, setOpenUnits] =
    useState([1]);


  /* =====================================================
     HELPERS PROGRES
  ===================================================== */

  const getLessonKey = (
    unitId,
    lessonId
  ) => {
    return `${unitId}-${lessonId}`;
  };


  const isLessonCompleted = (
    unitId,
    lessonId
  ) => {
    return mockProgress.completedLessons.includes(
      getLessonKey(
        unitId,
        lessonId
      )
    );
  };


const [selectedUnitId, setSelectedUnitId] = useState(null);

  const isCurrentLesson = (
    unitId,
    lessonId
  ) => {
    return (
      mockProgress.currentLesson?.unitId ===
        unitId &&
      mockProgress.currentLesson?.lessonId ===
        lessonId
    );
  };


  /* =====================================================
     UNITATE FINALIZATA
  ===================================================== */

  const isUnitCompleted = (
    unit
  ) => {
    return unit.lessons.every(
      (lesson) =>
        isLessonCompleted(
          unit.id,
          lesson.id
        )
    );
  };


  /* =====================================================
     UNITATE BLOCATA

     Unitatea 1 este mereu disponibila.

     O unitate urmatoare se deblocheaza doar daca
     unitatea anterioara este finalizata.
  ===================================================== */
const isUnitLocked = () => {
  return false;
};

  /* =====================================================
     LECTIE BLOCATA

     Daca unitatea este blocata, toate lectiile sunt blocate.

     In interiorul unei unitati disponibile:
     - prima lectie este disponibila
     - urmatoarea se deblocheaza dupa finalizarea precedentei
  ===================================================== */

const isLessonLocked = () => {
  return false;
};


  /* =====================================================
     PROGRES UNITATE
  ===================================================== */

  const getUnitProgress = (
    unit
  ) => {
    const total =
      unit.lessons.length;

    if (total === 0) {
      return 0;
    }

    const completed =
      unit.lessons.filter(
        (lesson) =>
          isLessonCompleted(
            unit.id,
            lesson.id
          )
      ).length;

    return Math.round(
      (completed / total) *
        100
    );
  };


  /* =====================================================
     PROGRES GENERAL
  ===================================================== */

  const totalLessons =
    useMemo(() => {
      return courseUnits.reduce(
        (
          total,
          unit
        ) =>
          total +
          unit.lessons.length,
        0
      );
    }, []);


  const completedLessons =
    useMemo(() => {
      return courseUnits.reduce(
        (
          total,
          unit
        ) => {
          const completed =
            unit.lessons.filter(
              (lesson) =>
                isLessonCompleted(
                  unit.id,
                  lesson.id
                )
            ).length;

          return (
            total +
            completed
          );
        },
        0
      );
    }, []);


  const overallProgress =
    totalLessons > 0
      ? Math.round(
          (
            completedLessons /
            totalLessons
          ) *
            100
        )
      : 0;



      /* =====================================================
   LECTIA CURENTA / URMATOAREA LECTIE
===================================================== */

const currentLessonInfo =
  useMemo(() => {
    const currentUnit =
      courseUnits.find(
        (unit) =>
          unit.id ===
          mockProgress.currentLesson?.unitId
      );

    if (!currentUnit) {
      return null;
    }

    const currentLesson =
      currentUnit.lessons.find(
        (lesson) =>
          lesson.id ===
          mockProgress.currentLesson?.lessonId
      );

    if (!currentLesson) {
      return null;
    }

    return {
      unit: currentUnit,
      lesson: currentLesson,
    };
  }, []);


  /* =====================================================
     DESCHIDERE / INCHIDERE UNITATE
  ===================================================== */

  const toggleUnit = (
    unitId
  ) => {
    setOpenUnits(
      (prev) => {
        if (
          prev.includes(
            unitId
          )
        ) {
          return [];
        }

        return [
          unitId,
        ];
      }
    );
  };


  /* =====================================================
     CLICK LECTIE
  ===================================================== */

  const handleLessonClick = (
    unit,
    lesson,
    locked
  ) => {
    if (locked) {
      return;
    }

    navigate(
      '/contabilitate-primara/lesson',
      {
        state: {
          unitId:
            unit.id,

          lessonId:
            lesson.id,

          lessonType:
            lesson.type,
        },
      }
    );
  };


  /* =====================================================
     CONTINUA CURSUL
  ===================================================== */

  const handleContinue =
    () => {
      const currentUnit =
        courseUnits.find(
          (unit) =>
            unit.id ===
            mockProgress
              .currentLesson
              ?.unitId
        );

      const currentLesson =
        currentUnit?.lessons.find(
          (lesson) =>
            lesson.id ===
            mockProgress
              .currentLesson
              ?.lessonId
        );

      if (
        !currentUnit ||
        !currentLesson
      ) {
        return;
      }

      handleLessonClick(
        currentUnit,
        currentLesson,
        false
      );
    };


  /* =====================================================
     ICON TIP LECTIE
  ===================================================== */

  const getLessonIcon = (
    type
  ) => {
    switch (type) {
      case 'practice':
        return faStar;

      case 'mission':
        return faBullseye;

      case 'project':
        return faTrophy;

      default:
        return faBookOpen;
    }
  };


  /* =====================================================
     LABEL TIP LECTIE
  ===================================================== */

  const getLessonTypeLabel = (
    type
  ) => {
    switch (type) {
      case 'practice':
        return 'Aplicatie';

      case 'mission':
        return 'Misiune';

      case 'project':
        return 'Proiect final';

      default:
        return 'Lectie';
    }
  };


  /* =====================================================
     RENDER
  ===================================================== */

  return (
    <div className="conta-primara-course-page">
      <div className='conta-primara-stats-design-top'>
        <TopBar/>
      </div>
   
    {selectedUnitId ? (
      <ContaPrimaraSyllabus
        unitId={selectedUnitId}
        onBack={() => setSelectedUnitId(null)}
      />
    ) : (

      <div className="conta-primara-course-shell">


        {/* =================================================
            HERO
        ================================================= */}

        <section className="conta-primara-course-hero">

          <div className="conta-primara-course-hero-content">

            


            <h1>
              {
                contaPrimaraCourseData.title
              }
            </h1>


            <p className="conta-primara-course-description">
              {
                contaPrimaraCourseData.description
              }
            </p>


            <div className="conta-primara-course-progress-block">

              <div className="conta-primara-course-progress-top">

                <span>
                  Progres curs
                </span>

                <strong>
                  {overallProgress}%
                </strong>

              </div>


              <div className="conta-primara-course-progress-bar">

                <div
                  className="conta-primara-course-progress-fill"
                  style={{
                    width:
                      `${overallProgress}%`,
                  }}
                />

              </div>


              <div className="conta-primara-course-progress-meta">

                {completedLessons}
                {' '}
                din
                {' '}
                {totalLessons}
                {' '}
                lectii finalizate

              </div>

            </div>


            <div
              type="button"
              className="conta-primara-course-continue"
              onClick={
                handleContinue
              }
            >
              <p>Continua cursul</p>

              <FontAwesomeIcon
                icon={faPlay}
              />
            </div>

{currentLessonInfo && (
  <div className="conta-primara-course-next-lesson">

    <div className="conta-primara-course-next-lesson-icon">
      <FontAwesomeIcon icon={faBookOpen} />
    </div>

    <div className="conta-primara-course-next-lesson-content">

      <span className="conta-primara-course-next-lesson-label">
        URMATOAREA LECTIE
      </span>

      <strong>
        {currentLessonInfo.lesson.title}
      </strong>

      <span className="conta-primara-course-next-lesson-unit">
        Unitatea {currentLessonInfo.unit.id}
        {' · '}
        {currentLessonInfo.unit.title}
      </span>

    </div>

    <button
      type="button"
      className="conta-primara-course-next-lesson-button"
      onClick={handleContinue}
      aria-label="Continua lectia"
    >
      <FontAwesomeIcon icon={faArrowRight} />
    </button>

  </div>
)}


          </div>


          <div className="conta-primara-course-mascot-wrapper">

            <img
              src={contiMascot}
              alt="Conti"
              className="conta-primara-course-mascot"
            />

          </div>

        </section>


        {/* =================================================
            HEADER UNITATI
        ================================================= */}

        <div className="conta-primara-course-section-heading">

          <div>

          

            <h2>
              Unitati de invatare
            </h2>

          </div>


          <p>
            Parcurge lectiile in ordine pentru a debloca urmatoarele unitati.
          </p>

        </div>


        {/* =================================================
            UNITATI
        ================================================= */}

        <section className="conta-primara-course-units">

          {courseUnits.map(
            (
              unit,
              unitIndex
            ) => {

              const isOpen =
                openUnits.includes(
                  unit.id
                );

              const unitLocked =
                isUnitLocked(
                  unitIndex
                );

              const unitProgress =
                getUnitProgress(
                  unit
                );

              const unitCompleted =
                isUnitCompleted(
                  unit
                );


              return (
                <article
                  key={
                    unit.id
                  }
                  className={[
                    'conta-primara-unit-card',

                    unitLocked
                      ? 'is-locked'
                      : '',

                    unitCompleted
                      ? 'is-completed'
                      : '',

                    isOpen
                      ? 'is-open'
                      : '',
                  ]
                    .filter(
                      Boolean
                    )
                    .join(
                      ' '
                    )}
                >


                  {/* =======================================
                      HEADER UNITATE
                  ======================================= */}

                  <button
                    type="button"
                    className="conta-primara-unit-header"
                    onClick={() =>
                      toggleUnit(
                        unit.id
                      )
                    }
                  >

                    <div className="conta-primara-unit-number">

                      {unitLocked ? (
                        <FontAwesomeIcon
                          icon={
                            faLock
                          }
                        />
                      ) : unitCompleted ? (
                        <FontAwesomeIcon
                          icon={
                            faCheck
                          }
                        />
                      ) : (
                        unitIndex +
                        1
                      )}

                    </div>


                    <div className="conta-primara-unit-header-content">

                    


                      <h3>
                        {unit.title}
                      </h3>


                      <p>
                        {
                          unit.description
                        }
                      </p>

                    </div>


                    <div className="conta-primara-unit-header-right">

                      <div className="conta-primara-unit-progress">

                        <strong>
                          {
                            unitProgress
                          }
                          %
                        </strong>


                        <div className="conta-primara-unit-progress-bar">

                          <div
                            className="conta-primara-unit-progress-fill"
                            style={{
                              width:
                                `${unitProgress}%`,
                            }}
                          />

                        </div>

                      </div>


                      <FontAwesomeIcon
                        icon={
                          isOpen
                            ? faChevronUp
                            : faChevronDown
                        }
                        className="conta-primara-unit-chevron"
                      />

                    </div>

                  </button>


                  {/* =======================================
                      LECTII
                  ======================================= */}

                  {isOpen && (
                    <div className="conta-primara-unit-content">

                      {unit.lessons.map(
                        (
                          lesson,
                          lessonIndex
                        ) => {

                          const completed =
                            isLessonCompleted(
                              unit.id,
                              lesson.id
                            );

                          const current =
                            isCurrentLesson(
                              unit.id,
                              lesson.id
                            );

                          const locked =
                            isLessonLocked(
                              unit,
                              unitIndex,
                              lessonIndex
                            );


                          return (
                            <button
                              key={
                                lesson.id
                              }
                              type="button"
                              className={[
                                'conta-primara-lesson-row',

                                completed
                                  ? 'is-completed'
                                  : '',

                                current
                                  ? 'is-current'
                                  : '',

                                locked
                                  ? 'is-locked'
                                  : '',

                                lesson.type
                                  ? `is-${lesson.type}`
                                  : '',
                              ]
                                .filter(
                                  Boolean
                                )
                                .join(
                                  ' '
                                )}
                              onClick={() =>
                                handleLessonClick(
                                  unit,
                                  lesson,
                                  locked
                                )
                              }
                              disabled={
                                locked
                              }
                            >


                              {/* STATUS */}

                              <div className="conta-primara-lesson-status">

                                {completed ? (
                                  <FontAwesomeIcon
                                    icon={
                                      faCheck
                                    }
                                  />
                                ) : locked ? (
                                  <FontAwesomeIcon
                                    icon={
                                      faLock
                                    }
                                  />
                                ) : current ? (
                                  <FontAwesomeIcon
                                    icon={
                                      faPlay
                                    }
                                  />
                                ) : (
                                  lessonIndex +
                                  1
                                )}

                              </div>


                              {/* CONTINUT */}

                              <div className="conta-primara-lesson-main">

                                <div className="conta-primara-lesson-type">

                                  <FontAwesomeIcon
                                    icon={getLessonIcon(
                                      lesson.type
                                    )}
                                  />

                                  {getLessonTypeLabel(
                                    lesson.type
                                  )}

                                </div>


                                <strong>
                                  {
                                    lesson.title
                                  }
                                </strong>

                              </div>


                              {/* ACTIUNE */}

                              <div
                                className={[
                                  'conta-primara-lesson-action',
                                  completed
                                    ? 'is-finished'
                                    : locked
                                    ? 'is-locked-action'
                                    : current
                                    ? 'is-continue'
                                    : 'is-start'
                                ].join(' ')}
                              >
                                <FontAwesomeIcon
                                  icon={
                                    completed
                                      ? faCircleCheck
                                      : locked
                                      ? faLock
                                      : current
                                      ? faCirclePlay
                                      : faPlay
                                  }
                                />
                              </div>

                            </button>
                          );
                        }
                      )}

                      <div className="conta-primara-unit-footer">

  <button
    type="button"
    className="conta-primara-unit-footer-secondary"
  onClick={(event) => {
  event.stopPropagation();
  setSelectedUnitId(unit.id);
}}
  >
    Vezi programa
  </button>

  <button
    type="button"
    className="conta-primara-unit-footer-primary"
    onClick={(event) => {
      event.stopPropagation();

      const nextLesson =
        unit.lessons.find(
          (lesson) =>
            !isLessonCompleted(
              unit.id,
              lesson.id
            )
        );

      if (nextLesson) {
        handleLessonClick(
          unit,
          nextLesson,
          false
        );
      }
    }}
  >
    {unitCompleted ? 'Recapituleaza' : 'Continua'}
  </button>

</div>

                    </div>
                  )}

                </article>
              );
            }
          )}

        </section>

      </div>
 )}
    </div>
  );
};

export default ContaPrimaraCourse;